import gql from "graphql-tag";

export const acceptInvite = gql`
  mutation AcceptInvite(
    $input: AcceptInviteInput!) {
    acceptInvite(input: $input) {
      project {
        id
      }
    }
  }
`;

export const acceptInviteOptions = {
  name: "acceptInvite",
};
